module.exports = {
  index: {
    aboutXiHe: "关于西河",
    aboutDesc: "专业铆钉生产 | 技术导向连接世界",
    aboutName: "SAILUK西河五金制品有限公司",
    product: "了解更多",
    contact: {
      desc: "对我们的产品有兴趣吗？欢迎与我们联系",
      btn: "联系我们"
    },
    quality: {
      a: "严密监测",
      b: "专业设备",
      c: "尖端技术",
      d: "值得你信赖",
      btn: "品质管理"
    }
  },
  menu: {
    back_home: "回首页",
    product: "产品中心",
    solution: "解决方案",
    about: "关于西河",
    index: "首页",
    search: "输入关键字",
    contact: "联系我们",
    back: "回上页"
  },
  contact: {
    mobile: "吴经理",
    tel: "公司电话",
    email: "EMAIL",
    form: {
      name: "姓名 *",
      tel: "电话 *",
      title: "标题 *",
      content: "内容 *"
    },
    send: "确认送出"
  },
  solution: {
    title: "汽车紧固方案",
    p1:
      "新能源汽车全球市场规模在加速扩张，推动了新能源汽车的快速发展，人们对新能源汽车购买需求也再不断提升。",
    p2: "紧固件的优劣好坏，对于新能源汽车各个模块的支撑有着不可估量的作用。",
    p3:
      "西河铆钉可以根据我们行业经验，从一开始为您做出正确的决策！西河铆钉为新能源电池包的紧固以及安全提供一系列的解决方案，在质量上一直是行业的标准，严格的西河铆钉标准，是我们一直要求的生产基本。"
  },
  sdwyj: {
    title: "科研技术紧固方案",
    p1:
      "SAILUK为中国射电望远镜提供面板紧固解决方案，针对户外的使用环境，使用耐腐蚀性的材料，高效制造符合大型科研技术设备要求的铆钉。"
  },
  xnyqc: {
    title: "应用领域"
  },
  txt: {
    sjyy: "实际应用",
    fzlc: "发展历程 ",
    xhpk: "西河品控 ",
    zzrz: "资质认证  ",
    cpys: "产品优势"
  },
  gfjgfa: {
    title: "光伏紧固方案",
    p1: "太阳能光伏和太阳热能。",
    p2:
      "西河为可再生能源领域创造了紧固解决方案，实现了安装太阳能模块结构的多种选择。",
    p3:
      "西河铆钉专为最苛刻的应用而设计，这些应用需要出色的抗拉力和抗剪力。它们安装快速且易于安装。"
  },
  gdjt: {
    title: "轨道交通紧固方案",
    p1:
      "在高铁一些需要承载作用力的部分，可以选择结构型铆钉，结构型铆钉相对于普通铆钉，其具有更高的强度，防松能力强，安全性能更高。产品主要有内锁拉丝铆钉，外锁拉丝铆钉，海马钉等。"
  },
  htjs: {
    title: "航天技术紧固方案",
    p1:
      "航空工业中有一句箴言：“为减轻每一克重量而奋斗。”为了将飞机上的整体质量降到最低，研发团队会考虑保证机身安全的情况下，对飞机上的结构进行合理化减重。",
    p2:
      "其中在飞机的蒙皮上，对其的紧固不能使用焊接等工艺，西河铆钉能够为你解决紧固难题。在保证机身完整性及安全的情况下，西河铆钉紧固是不二首选。"
  },
  product: {
    btn: "详细规格",
    length: "长度",
    grip: "铆接范围",
    shear: "抗拉力",
    tensile: "抗剪力",
    part: "产品编码",
    contactus: "联系我们",
    material: {
      material: "材质",
      finish: "表面处理"
    }
  },
  footer: {
    left: {
      desc:
        "年产超过30亿只铆钉，先进的设备，高质量的产品，优秀的行业解决方案，杰出的服务，品质即是我们的价值",
      sign: "西河五金"
    },
    info: {
      name: "SAILUK西河五金制品有限公司",
      address: "广东省佛山市南海区丹灶镇罗行杜家东坑工业区13号之一",
      rivet: "抽芯铆钉"
    },
    web: {
      title: "网站导览",
      index: "首页",
      about: "公司介绍",
      quality: "品质管理",
      product: "产品介绍",
      contact: "联系我们"
    },
    mobile: {
      title: "保持联系"
    }
  },

  about: {
    profileContent:
      "西河五金制品有限公司年产超过30亿只铆钉，团队规模超过200位员工及30人技术团队。占地10,000多平方米的厂房，部份产品销往德、韩、日、欧美等国，众多知名品牌都曾采用西河出品的铆钉，品质即是我们的价值。",
    profileContent2: "SAILUK是佛山市南海区西河五金制品有限公司旗下品牌",
    companyDesc:
      "1990年成立至今，近三十年的铆钉生产经验，秉持团队规范的管理方式、扎实的制作技术，带给不同的合作伙伴具有效率的商业模式。",
    efficientCollaboration: {
      p1:
        "西河自有一套企业管理办法，迅速回应用户的需要，同时能客制化生产高质量铆钉。",
      p2: "累计近三十年经验的管理与技术团队，在铆钉的应用经验上相当广泛。",
      p3: "足够提供不间断的产品与可靠的服务，是您信赖的好伙伴。",
      p4: "客制产品、专业品质，成为客户",
      p5: "信赖首选",
      quality: "品质",
      rapid: "迅速",
      custom: "客制化"
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/cn.js